import reduceReducers from "reduce-reducers";

import { ENVD_DOCUMENT } from "constants/actionTypes";

import {
  apiModelOfflineFetchReducer,
  apiModelOfflineUpdateReducer,
  reduceById,
} from "lib/reducers";
import { deserializeEnvdDocument } from "lib/serializers/envd";

const fetch = apiModelOfflineFetchReducer(ENVD_DOCUMENT, {
  deserializer: deserializeEnvdDocument,
});

const update = apiModelOfflineUpdateReducer(ENVD_DOCUMENT, {
  deserializer: deserializeEnvdDocument,
});

const refreshReducer = (state, action) => {
  switch (action.type) {
    case ENVD_DOCUMENT.REFRESH.SUCCESS: {
      // Refresh endpoint returns a full, NON-CACHED list of documents
      // replace the entire state with the most up-to-date items.
      const lastModifiedTimestamp =
        action.meta?.lastModifiedTimestamp || state.lastModifiedTimestamp;
      return {
        ...state,
        isFetching: false,
        byId: reduceById(action.payload.map(deserializeEnvdDocument)),
        lastModifiedTimestamp,
      };
    }
    default:
      return state;
  }
};

const envdDocumentReducer = reduceReducers(refreshReducer, fetch, update);

export default envdDocumentReducer;
